<template>
  <div class="apiget_dlglq">
    <div class="apiget_dlglq_div">
      <div class="apiget_dlglq_div_div">
        <div class="apiget_dlglq_div_div_div">
          <div class="apiget_dlglq_div_H">基础配置</div>
          <div class="apiget_dlglq_div_text">*本功能需在境外网络环境使用</div>
        </div>
      </div>
      <div class="apiget_dlglq_divB">
        <div class="apiget_dlglq_divB_div">
          <div class="apiget_dlglq_divB_div_div">
            <div class="apiget_dlglq_divB_div_div_div">
              <span class="apiget_dlglq_divB_div_div_div_span">代理服务器</span>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button type="primary">免费申请</el-button>
            </div>

            <div class="">
              <el-button plain>免费申请</el-button>
              <el-button type="primary">如有疑问，请联系客服</el-button>
            </div>
          </div>
        </div>
        <div class="apiget_dlglq_divB_divB">
          <div class="but_div">
            <div class="but_div_div">
              <div class="but_div_div_H">代理管理配置</div>
              <div class="but_div_div_text">
                <span class="but_div_div_textB">扣费模式</span>
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in kfms"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div></div>
              <div></div>
            </div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options:[],
      kfms: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
    };
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style>
.but_div {
  display: flex;
  justify-content: space-between;
}
.but_div_div {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
.apiget_dlglq_divB_div_div_div {
}

.apiget_dlglq_divB_div_div_div_span {
  margin-right: 10px;
}

.apiget_dlglq_divB_div_div_div > div {
  margin-right: 10px;
}

.apiget_dlglq_div_H {
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  color: #18181b;
  font-weight: 700;
  margin-right: 20px;
}

.apiget_dlglq_div {
}
.apiget_dlglq_div_div > div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.apiget_dlglq_div_div_div {
  border-bottom: 1px solid #c2c2c2;
}
.apiget_dlglq_div_text {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  color: #f64e60;
  margin-right: 52px;
  margin-top: 25px;
}
.apiget_dlglq_divB_div_div {
  display: flex;
  justify-content: space-between;
  padding-right: 50px;
  padding-left: 40px;
}
.but_div {
  margin-top: 20px;
  width: 1510px;
  height: 583px;
  background-color: #98989b;
  border-radius: 10px;
}
.but_div_div_H {
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  color: #18181b;
  font-weight: 700;
  margin-right: 20px;
}
.but_div_div_text {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium;
    color: #333;
    margin-right: 24px;
    padding-top: 12px;
}
.but_div_div_textB{
    font-size: 14px;
    font-family: SourceHanSansCN-Medium;
    color: #333;
    margin-right: 40px;
    padding-top: 12px;
}

.apiget_dlglq_divB_divB {

}
</style>